module.exports = __webpack_public_path__ + "static/media/varify-badge-step2-mobile.853b2cf6.png";